import { useCallback, useEffect, useMemo, useState } from 'react';
import type { FeatureEntitlement } from '@alltrails/types/FeatureEntitlement';
import type { User } from '@alltrails/types/User';
import { get } from '../utils/get';

const useFeaturePreviewEligibility = (feature: FeatureEntitlement, user: User | null) => {
  const [isEligible, setIsEligible] = useState<boolean>(); // Undefined signifies that we aren't sure yet

  useEffect(() => {
    async function getEligibility() {
      if (user) {
        try {
          const { users } = await get<{ users: { previewFeatureEntitlements?: FeatureEntitlement[] }[] }>('/api/alltrails/me');
          if (users.length) {
            const { previewFeatureEntitlements } = users[0];
            setIsEligible(Boolean(previewFeatureEntitlements?.includes(feature)));
          }
          // eslint-disable-next-line unused-imports/no-unused-vars
        } catch (error) {
          setIsEligible(false);
        }
      }
    }
    getEligibility();
  }, [feature, user]);

  const markIneligible = useCallback(() => {
    setIsEligible(false);
  }, []);

  return useMemo(() => ({ isEligible, markIneligible }), [isEligible, markIneligible]);
};

export default useFeaturePreviewEligibility;
